<template>
	<div>
		<h4 class="section-title">Edit course</h4>
		<form @submit.prevent="onSubmit">
			
			<div class="form-group input-content">
				<label>Name</label>
				<input type="text" v-model="course_data.name" class="form-control" v-validate="'required'" name="name">
				<span class="input-error-msg">{{ errors.first('name') }}</span>
			</div>

			<div class="form-group input-content">
				<label>Description</label>
				<input type="text" v-model="course_data.description" class="form-control" v-validate="'required'" name="description">
				<span class="input-error-msg">{{ errors.first('description') }}</span>
			</div>

			<button type="submit" class="button">Submit</button>
			<router-link :to="{ name : 'admin.courses.index' }" tag="button" class="button dark-button">Back</router-link>
		</form>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			course_data : {
				name : '',
				description : ''
			}
		}
	},

	created : function(){
		this.getCourse();
	}, 

	methods : {
		getCourse : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getCourse', params).then((res) => {
				this.course_data = res.data.data;
			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editCourse', this.course_data).then((res) => {
						console.log("OK", res);
						this.$router.push({ name : 'admin.courses.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/courses/AdminCourseEditComponent.vue